(function () {
  var bar = document.getElementById('pikl-sticky-atc');
  if (!bar) return;
  var mainBtn = document.querySelector('.product-single__box__block--buy_buttons .js-product-add');
  var buyBlock = document.querySelector('.product-single__box__block--buy_buttons');
  var priceBlock = document.querySelector('.product-single__box__block--price');
  var barBtn = bar.querySelector('.pikl-sticky-atc__btn');
  var barPrice = bar.querySelector('.pikl-sticky-atc__price');
  if (!mainBtn || !buyBlock) return;

  // Proxy the bar button to the real Add-to-cart button.
  barBtn.addEventListener('click', function () { mainBtn.click(); });

  function syncPrice() {
    if (!priceBlock || !barPrice) return;
    var src = priceBlock.querySelector('.price__number') || priceBlock.querySelector('.money');
    if (src) barPrice.textContent = src.textContent.trim();
  }
  function mainLabel() {
    // Mirror the real buy button's label so the bar follows i18n + pre-order/sold-out state.
    var el = mainBtn.querySelector('.staged-action__text');
    return ((el ? el.textContent : mainBtn.textContent) || '').trim();
  }
  function syncDisabled() {
    var disabled = mainBtn.hasAttribute('disabled');
    if (disabled) { barBtn.setAttribute('disabled', ''); }
    else { barBtn.removeAttribute('disabled'); }
    var label = mainLabel();
    if (label) barBtn.textContent = label;
  }
  syncPrice();
  syncDisabled();
  if (priceBlock) new MutationObserver(syncPrice).observe(priceBlock, { childList: true, subtree: true, characterData: true });
  new MutationObserver(syncDisabled).observe(mainBtn, { attributes: true, attributeFilter: ['disabled'] });

  // Show the bar whenever the main Add-to-cart has scrolled above the viewport.
  // rAF-throttled scroll check is robust for fast/jump scrolls (an IntersectionObserver
  // threshold crossing can be skipped when the element leaves the viewport in one jump).
  var ticking = false;
  function update() {
    ticking = false;
    var show = buyBlock.getBoundingClientRect().bottom < 0;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
  }
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
